if (!customElements.get('sm-newcomer-slideshow')) {
  customElements.define('sm-newcomer-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.nc-slide')];
      this.index = 0;
      this.abort = new AbortController();
      const on = (target, event, callback) => target?.addEventListener(event, callback, { signal: this.abort.signal });
      on(this.querySelector('[data-prev]'), 'click', () => this.go(this.index - 1, true));
      on(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1, true));
      on(this, 'focusin', () => this.stop());
      on(this, 'focusout', () => requestAnimationFrame(() => this.start()));
      on(this, 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(this, 'touchstart', event => { this.touch = [event.touches[0].clientX, event.touches[0].clientY]; });
      on(this, 'touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch[0];
        const dy = event.changedTouches[0].clientY - this.touch[1];
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      });
      on(document, 'visibilitychange', () => this.start());
      on(document, 'shopify:block:select', event => {
        const n = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (n >= 0) this.go(n, true);
      });
      on(document, 'shopify:block:deselect', () => this.start());
      this.start();
    }
    go(n, announce = false) {
      if (!this.slides.length) return;
      this.index = (n + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      const status = this.querySelector('.nc-status');
      if (status && announce) status.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      this.start();
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    start() {
      this.stop();
      // Focus pauses rotation only for keyboard users, not editor clicks or mouse hover.
      const keyboardFocus = this.contains(document.activeElement) && document.activeElement?.matches(':focus-visible');
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || document.hidden || keyboardFocus) return;
      this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); }
  });
}
